import * as React from 'react';
import { inject, observer } from 'mobx-react';
import AppState from '../states/AppState';
import { Dialog, Button, TextField, DialogTitle, DialogContent, DialogActions, Grid } from '@material-ui/core';
import ImgLogin from '@material-ui/icons/LockOpen';

export interface IPantLoginProps {
    appState: AppState;
}
@inject('appState')
@observer
class PantLogin extends React.Component<IPantLoginProps, {}> {
    private readonly appState: AppState = this.props.appState;

    handleChangeUsuari = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        this.appState.setUsuari(event.target.value);
    }

    handleChangePassword = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        this.appState.setPassword(event.target.value);
    }

    handleLogin = () => {
        // Fer el login
        this.appState.doLogin().then(() => {
            if (!this.appState.usr.partitCod || !this.appState.usr.sesCod) {
                this.appState.notiState.showMessage('Usuari o Contrassenya Incorrectes!', 'error');
            }
        }).catch((reason: any) => { this.appState.notiState.showMessage(String(reason), 'error')});
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.handleLogin();
    }

    render() {

        const formLogin = (
            <form onSubmit={this.handleSubmit}>
                <DialogTitle>Login</DialogTitle>
                <DialogContent style={{overflowY: 'hidden', marginBottom: 10}}>
                    <Grid container={true} spacing={3}>
                        <Grid item={true} xs={12}>
                            <TextField
                                autoFocus={true}
                                placeholder="Usuari"
                                label="Usuari"
                                fullWidth={true}
                                value={this.appState.usr.userId}
                                onChange={this.handleChangeUsuari}
                            />
                        </Grid>
                        <Grid item={true} xs={12}>
                            <TextField
                                placeholder="Contrassenya"
                                label="Contrassenya"
                                type="password"
                                fullWidth={true}
                                value={this.appState.usr.passWd}
                                onChange={this.handleChangePassword}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                    >
                        <ImgLogin style={{marginRight: 5}}/> Login
                    </Button>
                </DialogActions>
            </form>
        );

        return !!this.appState.pantState.width && this.appState.pantState.width < 510 ? formLogin :
        (
            <Dialog
                open={true}
                className="Login"
                // modal={true}
                maxWidth="sm"
                fullWidth={true}
            >
                {formLogin}
            </Dialog>
        );
    }
}

export default PantLogin;
